import { useEffect } from 'react'

export const useSyncSelectedContacts = ({ fetchedContacts, setSelectedContacts, setNewDeal }) => {
  useEffect(() => {
    if (!fetchedContacts?.length) return

    setSelectedContacts(fetchedContacts)
    setNewDeal(prev => ({
      ...prev,
      contacts: fetchedContacts.map(contact => contact.contacts_uuid),
    }))
  }, [fetchedContacts])
}
